import { AppState } from '../../types/store';

export const selectReportSubmitted = (state: AppState): boolean =>
  state.reportProfile.reportSubmitted;

export const selectIsSubmitting = (state: AppState): boolean =>
  state.reportProfile.isSubmitting;
